import { Directive, ElementRef, HostListener } from '@angular/core';


@Directive({
	selector: '[vbSelectOnClick]',
	standalone: false
})
export class VbSelectOnClickDirective {
	constructor(
		private readonly el: ElementRef
	) { }

	@HostListener('click')
	public onClick() {
		this.el.nativeElement.select();
	}
}
